<!-- SEARCH -->
<div class="search" [ngClass]="active && 'state-search-active'">
  <!-- SEARCH OVERLAY -->
  <div class="search__overlay">
    <!-- SEARCH BOX -->
    <div
      class="search__box"
      [ngStyle]="{
        overflow:
          transitions.searchOpacity.interpolated > 0.9 ? 'visible' : 'hidden'
      }"
    >
      <!-- CLOSE BUTTON -->
      <div
        class="search__close"
        [ngStyle]="{
          display:
            transitions.searchOpacity.interpolated > 0.01 ? 'block' : 'none',
          transform:
            'translateY(-' +
            (1 - transitions.searchOpacity.interpolated) +
            'rem)',
          opacity: transitions.searchOpacity.interpolated
        }"
      >
        <a (click)="onClose()"
          ><span class="icon icon-close icon--tilt"></span
        ></a>
      </div>
      <!-- /CLOSE BUTTON -->

      <!-- MAIN PART OF THE SEARCH BOX -->
      <div class="search__section">
        <!-- SEARCH BAR -->
        <div class="search__search-bar search__cell search__cell--head">
          <app-search-btn
            className="search__icon"
            (click)="onOpen()"
          ></app-search-btn>

          <input
            class="search__input title title--h4"
            type="text"
            [placeholder]="translate.instant('Common.Search.title')"
            [(ngModel)]="params.keywords"
            (focus)="onOpen()"
            (keyup)="onKeywordsKeyUp($event)"
          />

          <app-reset-btn
            className="search__clear"
            *ngIf="active && params.keywords"
            (click)="onClickClearKeywords()"
          ></app-reset-btn>
        </div>
        <!-- /SEARCH BAR -->

        <!-- FILTERS -->
        <div
          class="search__filters search__cell search__cell--head"
          (click)="toggle()"
        >
          <div
            class="search__border"
            [ngStyle]="{
              transform:
                'scaleY(' + (1 - transitions.searchOpacity.interpolated) + ')',
              opacity: 1 - transitions.searchOpacity.interpolated
            }"
          ></div>
          <span
            class="filter__icon"
            [ngClass]="[
              active ? 'active' : '',
              filterIcon === 'hover' ? 'hover' : ''
            ]"
          >
            <span class="filter__icon__line"></span>
            <span class="filter__icon__line"></span>
            <span class="filter__icon__line"></span>
          </span>
          <span
            class="search__filters-heading title title--h4"
            (mouseover)="filterOver()"
            (mouseout)="filterOut()"
          >
            {{ 'Common.Search.filters' | translate }}
          </span>

          <span
            class="search__filters-count"
            [ngStyle]="{
              display:
                transitions.filterCount.interpolated > 0.01
                  ? 'inline-block'
                  : 'none',
              transform:
                'translateX(-' +
                (1 - transitions.filterCount.interpolated) +
                'rem)',
              opacity: transitions.filterCount.interpolated
            }"
          >
            ({{ filterNumber }})
          </span>
        </div>
        <!-- /FILTERS -->
      </div>
      <!-- /MAIN PART OF THE SEARCH BOX -->

      <!-- SEARCH CONTAINER -->
      <div
        class="search__container height-wrap"
        [ngStyle]="{
          overflow:
            transitions.searchHeight.interpolated > 10 ? 'visible' : 'hidden',
          height: transitions.searchHeight.interpolated + 'px'
        }"
      >
        <div #searchContainer>
          <!-- "MORE" PART OF THE SEARCH BOX -->
          <div class="search__more search__section">
            <!-- KEYWORDS (POPULAR / SUGGESTED) -->
            <div class="search__keywords search__cell">
              <!-- KEYWORDS LOADING SPINNER -->
              <div
                class="search__keywords-loading"
                [ngStyle]="{
                  height: transitions.loading.interpolated * 1.5 + 'rem',
                  'margin-bottom': transitions.loading.interpolated * 2 + 'rem',
                  opacity: transitions.loading.interpolated
                }"
              >
                <app-spinner></app-spinner>
              </div>
              <!-- /KEYWORDS LOADING SPINNER -->

              <!-- SUGGESTIONS -->
              <div
                class="search__suggestions height-wrap height-wrap--bottom"
                [ngStyle]="{
                  height: transitions.suggestions.interpolated + 'px',
                  'margin-bottom':
                    transitions.suggestionsOpacity.interpolated * 2.5 + 'rem',
                  opacity: transitions.suggestionsOpacity.interpolated
                }"
              >
                <div #suggestionsContainer>
                  <div class="search__tag-list">
                    <app-tag-list
                      [tags]="searchSuggestions"
                      (onClick)="setKeywords($event.value)"
                      [hub] = "topicOrType"
                    >
                    </app-tag-list>
                  </div>
                </div>
              </div>
              <!-- /SUGGESTIONS -->

              <!-- POPULAR KEYWORDS -- TODO: ACTIVATE WHEN READY
              <div class="search__popular-keywords">
                <div class="search__heading subtitle--two">{{'Common.Search.popular_keywords'|translate}}</div>
                <div class="search__tag-list">
                  <app-tag-list
                    [tags]="popularKeywords"
                    (onClick)="setKeywords($event)"
                  > </app-tag-list>
                </div>
              </div>
              !-- /POPULAR KEYWORDS -->
            </div>
            <!-- /KEYWORDS (POPULAR / SUGGESTED) -->

            <!-- FILTER OPTIONS -->
            <div
              class="search__filters-options search__cell"
              [ngStyle]="{
                transform:
                  'translateY(-' +
                  (1 - transitions.searchOpacity.interpolated) +
                  'rem)',
                opacity: transitions.searchOpacity.interpolated
              }"
            >
              <div class="search__filters-options-heading">
                <span
                  class="filter__icon"
                  [ngClass]="[
                    active ? 'active' : '',
                    filterIcon === 'hover' ? 'hover' : ''
                  ]"
                >
                  <span class="filter__icon__line"></span>
                  <span class="filter__icon__line"></span>
                  <span class="filter__icon__line"></span>
                </span>
                <span
                  class="search__filters-heading title title--h4"
                  (mouseover)="filterOver()"
                  (mouseout)="filterOut()"
                >
                  {{ 'Common.Search.filters' | translate }}
                </span>

                <span
                  class="search__filters-count"
                  [ngStyle]="{
                    display:
                      transitions.filterCount.interpolated > 0.01
                        ? 'inline-block'
                        : 'none',
                    transform:
                      'translateX(-' +
                      (1 - transitions.filterCount.interpolated) +
                      'rem)',
                    opacity: transitions.filterCount.interpolated
                  }"
                >
                  ({{ filterNumber }})
                </span>
              </div>

              <ng-select
                placeholder="{{ 'Common.Forms.Levels.all' | translate }}"
                [searchable]="true"
                [clearable]="false"
                (change)="filterChange()"
                [(ngModel)]="params.filters.level"
              >
                <ng-option
                  *ngFor="let level of filtersLevels"
                  [value]="level[0] === 'all' ? '' : level[0].replace('l', '')"
                >
                  {{ level[1] }}
                </ng-option>
              </ng-select>

              <div *ngIf="topic && !isTopicRevision">
                <ng-select
                  [placeholder]="translate.instant('Common.Search.Types.all')"
                  (change)="filterChange()"
                  [searchable]="true"
                  [clearable]="false"
                  [(ngModel)]="params.filters.type"
                >
                  <ng-option
                    *ngFor="let type of filtersTypes"
                    [value]="type[0] === 'all' ? '' : type[0]"
                  >
                    {{ type[1] }}
                  </ng-option>
                </ng-select>
              </div>

              <div *ngIf="type">
                <ng-select
                  [placeholder]="topicsPlaceholder"
                  (change)="filterChange()"
                  [searchable]="true"
                  [clearable]="false"
                  [(ngModel)]="params.filters.topic"
                >
                  <ng-container *ngFor="let topic of filtersTopics">
                    <ng-option
                      *ngIf="topic[0] !== 'english'"
                      [value]="topic[0] === 'all' ? '' : topic[0]"
                    >
                      {{ topic[1] }}
                    </ng-option>
                  </ng-container>
                </ng-select>
              </div>
            </div>
            <!-- /FILTER OPTIONS -->

            <!-- NOTIONS -->
            <div class="search__notions search__cell">
              <!-- FIXME: when do we enable this?
              <a class="link link--sm">
                <span class="icon icon-notions-sm"></span><span class="link__text">{{'Common.Search.notions'|translate}}</span>
              </a>
              !-->
            </div>
            <!-- /NOTIONS -->

            <!-- ACTIONS -->
            <div class="search__actions search__cell">
              <div class="search__btn-wrap btn-wrapper">
                <button
                  class="search__submit-btn btn btn--sm"
                  (click)="onClose()"
                >
                  {{ 'Common.Menu.Search.title' | translate }}
                </button>
              </div>

              <div class="search__cancel-filters">
                <a
                  class="link link--sm"
                  (click)="resetFilters()"
                  [ngStyle]="{
                    display:
                      transitions.resetBtn.interpolated > 0.01
                        ? 'block'
                        : 'none',
                    opacity: transitions.resetBtn.interpolated
                  }"
                >
                  <span
                    class="icon-refresh-md icon icon--rotate icon--mobile"
                  ></span>
                  <span class="icon-refresh-sm icon icon--rotate"></span>
                  <span class="search__reset-label link__text">{{
                    'Common.Search.reset' | translate
                  }}</span>
                </a>
              </div>
            </div>
            <!-- /ACTIONS -->
          </div>
          <!-- /"MORE" PART OF THE SEARCH BOX -->
        </div>
        <!-- (height wrap) -->
      </div>
      <!-- SEARCH CONTAINER -->
    </div>
    <!-- /SEARCH BOX -->
  </div>
  <!-- /SEARCH OVERLAY -->
</div>
<!-- /SEARCH -->

<!-- SEARCH RESULTS -->
<div class="search__results">
  <!-- SEARCH RESULTS LOADER -->
  <div
    class="search__results-loader"
    [ngStyle]="{
      height: transitions.loadingResults.interpolated * 3.5 + 'rem',
      'margin-bottom': transitions.loadingResults.interpolated * 5 + 'rem',
      opacity: transitions.loadingResults.interpolated
    }"
  >
    <app-spinner></app-spinner>
  </div>
  <!-- /SEARCH RESULTS LOADER -->

  <!-- SEARCH RESULTS HEADER -->
  <div
    class="search__results-header height-wrap height-wrap--bottom"
    [ngStyle]="{
      height: transitions.resultsHeader.interpolated + 'px'
    }"
  >
    <div #resultsHeaderContainer>
      <h2 class="search__heading title title--h1alt">
        {{ resultsHeading }}
      </h2>
      <h3 *ngIf="!results.length" class="search__no-results title title--h3">
        {{ 'Common.Search.Results.no_results' | translate }}
      </h3>
    </div>
  </div>
  <!-- /SEARCH RESULTS HEADER -->

  <!-- SEARCH RESULTS CONTAINER -->
  <div
    class="search__results-container height-wrap"
    [ngStyle]="{
      height: transitions.results.interpolated + 'px',
      opacity: transitions.resultsOpacity.interpolated
    }"
  >
    <div #resultsContainer>
      <div class="search__grid grid grid--tiles grid--4col">
        <app-tile
          *ngFor="let result of results"
          [tile]="result"
          [format]="'medium'"
          [context]="'hub'"
        ></app-tile>
      </div>
    </div>
  </div>
  <!-- /SEARCH RESULTS CONTAINER -->

  <!-- SEARCH LOAD MORE / FIXME: extract from parent div? -->
  <div class="search__load-more">
    <div
      class="search__results-loader"
      [ngStyle]="{
        height: transitions.loadingMore.interpolated * 3.5 + 'rem',
        'margin-bottom': transitions.loadingMore.interpolated * 5 + 'rem',
        opacity: transitions.loadingMore.interpolated
      }"
    >
      <app-spinner></app-spinner>
    </div>

    <a
      class="btn btn--sm"
      (click)="loadMore()"
      [ngStyle]="{
        display: transitions.loadMoreBtn.interpolated > 0.01 ? 'block' : 'none',
        opacity: transitions.loadMoreBtn.interpolated
      }"
    >
      {{ 'Common.Search.Results.see_more' | translate }}
    </a>
  </div>
  <!-- /SEARCH LOAD MORE -->
</div>
<!-- /SEARCH RESULTS -->
